import { render, staticRenderFns } from "./call-in.vue?vue&type=template&id=cbd700c0&scoped=true"
import script from "./call-in.vue?vue&type=script&lang=ts"
export * from "./call-in.vue?vue&type=script&lang=ts"
import style0 from "./call-in.vue?vue&type=style&index=0&id=cbd700c0&prod&lang=less&scoped=true"
import style1 from "./call-in.vue?vue&type=style&index=1&id=cbd700c0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd700c0",
  null
  
)

export default component.exports